import { useState, forwardRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";
import TypeSelector from "./TypeSelector";
import TimeForm from "./TimeForm";
import FixedForm from "./FixedForm";

const SlideUp = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export default function LogWorkDialog({ open, onClose, onSubmitted }) {
  const [step, setStep] = useState("choose"); // "choose" | "time" | "fixed"
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => {
    onClose();
    setTimeout(() => setStep("choose"), 300);
  };

  const handleSubmit = async (body) => {
    setSubmitting(true);
    const result = await request("worklog/submit", "post", body);
    setSubmitting(false);
    if (result?.success) {
      toast.success("Submitted successfully");
      handleClose();
      onSubmitted();
    }
  };

  const title =
    step === "choose" ? "Log Work" : step === "time" ? "Log Time" : "Log Deliverable";

  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={SlideUp}>
      <AppBar position="sticky" elevation={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Toolbar>
          {step === "choose" ? (
            <IconButton edge="start" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          ) : (
            <IconButton edge="start" onClick={() => setStep("choose")} aria-label="back">
              <ArrowBackIcon />
            </IconButton>
          )}
          <Typography variant="h6" sx={{ ml: 1 }}>
            {title}
          </Typography>
          {submitting && (
            <CircularProgress size={20} color="inherit" sx={{ ml: "auto" }} />
          )}
        </Toolbar>
      </AppBar>

      {step === "choose" && <TypeSelector onSelect={setStep} />}
      {step === "time" && <TimeForm onSubmit={handleSubmit} submitting={submitting} />}
      {step === "fixed" && <FixedForm onSubmit={handleSubmit} submitting={submitting} />}
    </Dialog>
  );
}
